import { render, staticRenderFns } from "./OrderStatuses.vue?vue&type=template&id=4cb634f7"
import script from "./OrderStatuses.vue?vue&type=script&lang=ts"
export * from "./OrderStatuses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports